import React, { useState } from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { Link } from '@hz-design-system/web-ui';

import Classes from './DisclaimerText.scss';

type TDisclaimerText = {
  shortDisclaimerTextKey: string;
  showMoreTextKey?: string;
  fullDisclaimerText?: string;
};

const DisclaimerText = ({ shortDisclaimerTextKey, showMoreTextKey = '', fullDisclaimerText = '' }: TDisclaimerText) => {
  const [isExtraTextVisible, setExtraTextVisible] = useState(false);

  const linkClassName = `${Classes.link} ${isExtraTextVisible ? Classes.hiddenLink : ''}`;
  const fullMessageClassName = `${Classes.fullMessage} ${!isExtraTextVisible ? Classes.hiddenFullMessage : ''}`;

  const onLinkClick = (): void => {
    setExtraTextVisible(true);
  };

  return (
    <div className={Classes.container}>
      <Trans className={Classes.shortMessage} tagName="span" i18nKey={shortDisclaimerTextKey} />{' '}
      {Boolean(fullDisclaimerText) && (
        <Link className={linkClassName} onClick={onLinkClick}>
          <Trans className={Classes.linkText} tagName="span" i18nKey={showMoreTextKey} />
        </Link>
      )}
      <Trans tagName="div" i18nKey={fullDisclaimerText} className={fullMessageClassName} />
    </div>
  );
};

export default DisclaimerText;
